export default function (Component) {
      Component.options.__docs = "## Basic usage\n\n```\n<ds-copy-field>Copy me please!</ds-copy-field>\n```"
    }